
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export interface BikeDetails {
  id: string;
  model?: string;
  serial_number?: string;
  battery_percentage?: number | null;
  last_location_update?: string | null;
  last_update?: string | null;
  last_service_date?: string | null;
  photo_url?: string | null;
  speed?: number | null;
  current_speed?: number | null;
  mileage?: number | string;
  online?: boolean;
  status?: string;
  movement_blocked?: boolean;
  speed_limit?: number | null;
  max_allowed_speed?: number;
  last_movement_update?: string | null;
  gps_tag?: string | null;
}

export const useBikeDetails = (bikeId: string | null) => {
  const [bikeDetails, setBikeDetails] = useState<BikeDetails | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBikeDetails = async () => {
      if (!bikeId) {
        setBikeDetails(null);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        console.log('Загружаем детали велосипеда:', bikeId);

        const { data: bike, error: bikeError } = await supabase
          .from('bikes')
          .select(`
            id,
            model,
            serial_number,
            battery_percentage,
            last_update,
            last_service_date,
            gps_tag,
            speed,
            current_speed,
            mileage,
            online,
            status,
            movement_blocked,
            speed_limit,
            max_allowed_speed,
            last_movement_update
          `)
          .eq('id', bikeId)
          .single();

        if (bikeError) {
          console.error('Ошибка при загрузке данных велосипеда:', bikeError);
          setError(bikeError.message);
          toast.error(`Ошибка загрузки данных велосипеда: ${bikeError.message}`);
          return;
        }

        if (!bike) {
          console.warn('Велосипед не найден:', bikeId);
          setError('Велосипед не найден');
          return;
        }

        console.log('Получены детали велосипеда:', bike);
        setBikeDetails(bike);

      } catch (err: any) {
        console.error('Неожиданная ошибка при загрузке велосипеда:', err);
        setError(err.message || 'Неизвестная ошибка');
        toast.error(`Ошибка: ${err.message || 'Неизвестная ошибка'}`);
      } finally {
        setLoading(false);
      }
    };

    fetchBikeDetails();
  }, [bikeId]);

  return { bikeDetails, loading, error };
};
